var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 339,
    viewBox: "0 0 217 339",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5896_6624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.78 278.668V238L159 200H138.099V169.107H166.68V128.961L159 91H139L137.058 80L129 40H87.5619L87.0014 80V118H64L50 119L58 158.77C61.3825 159.291 64.2246 159.752 66.8065 160.152C67.3869 163.558 67.8673 166.343 68.4477 169.748H87.5619L80 219L87.5619 258.776C91.4047 259.356 94.2468 259.797 96.9488 260.218C97.3091 263.363 97.6093 265.947 97.9695 269.073C101.032 269.313 103.854 269.553 106.936 269.794C107.276 273.239 107.537 276.044 107.797 278.668H166.78Z",
    fill: "url(#paint0_linear_5896_6624)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159 200V240H100L99 230L90 229L88.9488 220.218C86.2468 219.797 80 219 80 219V130H61L59 120L50 119V91H79.0014V40H129V91H159V129.107H130.099L130 200H159Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 62,
    width: 4,
    height: 24,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121,
    y: 98,
    width: 4,
    height: 4,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 102,
    width: 4,
    height: 4,
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5896_6624",
    x: 0,
    y: 0,
    width: 216.781,
    height: 338.668,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.848333 0 0 0 0 0.458333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5896_6624"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5896_6624",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5896_6624",
    x1: 108.39,
    y1: 40,
    x2: 108.39,
    y2: 278.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA4CD4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTHover);
export default __webpack_public_path__ + "static/media/T_hover.e1a6a73b12252bdf7fd7d1934d3ffff2.svg";
export { ForwardRef as ReactComponent };